import { render, staticRenderFns } from "./Diplomas.vue?vue&type=template&id=4584cd81&"
import script from "./Diplomas.vue?vue&type=script&lang=js&"
export * from "./Diplomas.vue?vue&type=script&lang=js&"
import style0 from "./Diplomas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports